import React, { Component } from 'react';
import { connect } from 'react-redux';
import MainPage from "../pages/MainPage/MainPage";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PoliciesCreatePage from "../pages/PoliciesCreatePage/PoliciesCreatePage";
import CategoryDescription from "../pages/CategoryDescription/CategoryDescription";
import AboutUs from "../pages/AboutUs/AboutUs";
import ProductDetails from "../pages/ProductDetails/ProductDetails";
import TermsAndConditions from "../pages/TermsAndConditions/TermsAndConditions";
import ContactUs from "../pages/ContactUs/ContactUs";
import SalePoints from '../pages/SalePoints'
import { getCategories } from "../actions/categories";
import SearchResult from "../pages/SearchResult/SearchResult";
import Faq from "../pages/FAQ/Faq"
import ReactGA4 from 'react-ga4';
import {
    setActiveLanguage,
    getActiveLanguage,
    getTranslate
} from 'react-localize-redux';
import { languageUrls } from "./languageUrls";

class App extends Component {
    componentDidMount() {
        this.props.dispatch(getCategories())
    }

    componentWillMount() {
        let lang = window.location.pathname.split('/')[1];
        if (lang) {
            if (lang === 'ka' || lang === 'en' && lang === 'ru') {
                localStorage.setItem('currentLanguage', lang)
                this.props.dispatch(setActiveLanguage(lang));
            } else if (lang === 'policies') {
                if (!localStorage.getItem('currentLanguage')) {
                    localStorage.setItem('currentLanguage', 'ka')
                    lang = localStorage.getItem('currentLanguage');
                    this.props.dispatch(setActiveLanguage(lang));
                }
                let params = window.location.pathname.split('/');
                let curlanguage = localStorage.getItem('currentLanguage')
                this.props.dispatch(setActiveLanguage(curlanguage));
                let path = window.location.pathname.split('/')[1]
                let firstParam;
                if (curlanguage === 'ka') {
                    firstParam = 'polisebi'
                }
                if (curlanguage === 'en') {
                    firstParam = 'policies'
                }
                if (curlanguage === 'ru') {
                    firstParam = 'polici'
                }
                let changedPath = languageUrls.filter(item => item[curlanguage] === firstParam)
                let url = "/" + curlanguage + "/" + changedPath[0][curlanguage] + "/" + params[2] + "/" + params[3]
                window.history.replaceState(null, "", url);
            } else {
                localStorage.setItem('currentLanguage', lang)
                this.props.dispatch(setActiveLanguage(lang))
            }
        }
        else {
            localStorage.setItem('currentLanguage', 'ka')
            this.props.dispatch(setActiveLanguage('ka'));
        }

        // const url = "/" + lang + window.location.pathname;
        // window.history.replaceState(null, "", url);

        // else {
        //     localStorage.setItem('currentLanguage', 'ka')
        //     this.props.dispatch(setActiveLanguage('ka'));
        // }

        // this.props.dispatch(setActiveLanguage(localStorage.getItem('currentLanguage')))
    }

    render() {
        ReactGA4.initialize('G-FW600GS58Z');
        ReactGA4.send({hitType:"pageview", page: window.location.pathname + window.location.search});
        return (
            <div>
                <Router>
                    <Switch>
                        <Route exact path="/en/categorydescription" component={CategoryDescription} />
                        <Route exact path="/en/productdetails" component={ProductDetails} />
                        <Route exact path="/en/salespoints" activeStyle={{ color: 'red' }} component={SalePoints} />
                        <Route exact path="/en/faq" component={Faq} />
                        <Route exact path="/en/aboutus" component={AboutUs} />

                        <Route exact path="/en/contactus" component={ContactUs} />
                        <Route exact path="/en/termsandconditions" component={TermsAndConditions} />
                        <Route exact path="/en/policies" component={PoliciesCreatePage} />
                        <Route exact path="/en/policies/:policiesId/:status" component={PoliciesCreatePage} />
                        <Route exact path="/en/searchResult" component={SearchResult} />


                        <Route exact path="/ka/kategoriisagtsera" component={CategoryDescription} />
                        <Route exact path="/ka/produqtisdetalebi" component={ProductDetails} />
                        <Route exact path="/ka/gayidviswertilebi" activeStyle={{ color: 'red' }} component={SalePoints} />
                        <Route exact path="/ka/faq" component={Faq} />
                        <Route exact path="/ka/CvenSesaxeb" component={AboutUs} />
                        <Route exact path="/ka/kontaqti" component={ContactUs} />
                        <Route exact path="/ka/wesebidapirobebi" component={TermsAndConditions} />
                        <Route exact path="/ka/polisebi" component={PoliciesCreatePage} />
                        <Route exact path="/ka/polisebi/:policiesId/:status" component={PoliciesCreatePage} />
                        <Route exact path="/ka/searchResult" component={SearchResult} />


                        <Route exact path="/ru/opisaniekategorii" component={CategoryDescription} />
                        <Route exact path="/ru/detaliprodukta" component={ProductDetails} />
                        <Route exact path="/ru/tochkiprodaji" activeStyle={{ color: 'red' }} component={SalePoints} />
                        <Route exact path="/ru/faq" component={Faq} />
                        <Route exact path="/ru/onas" component={AboutUs} />
                        <Route exact path="/ru/kontakt" component={ContactUs} />
                        <Route exact path="/ru/pravilaiuslovia" component={TermsAndConditions} />
                        <Route exact path="/ru/polici" component={PoliciesCreatePage} />
                        <Route exact path="/ru/polici/:policiesId/:status" component={PoliciesCreatePage} />
                        <Route exact path="/ru/searchResult" component={SearchResult} />

                        <Route exact path="/*/" component={MainPage} />
                    </Switch>
                </Router>
            </div>
        );
    }
}
const mapStateToProps = ({ locale }) => ({
    currentLocale: getActiveLanguage(locale),
    translate: getTranslate(locale)
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js